import { toISODate } from "./date"

export const PAGE_TYPES = {
  BLOG: "BlogPosting",
  ABOUT: "AboutPage",
  CONTACT: "ContactPage",
  DEFAULT: "WebPage",
}

function getAddress({ country, region, city, streetAddress, postalCode }) {
  return {
    "@type": "PostalAddress",
    postalCode,
    streetAddress,
    addressLocality: city,
    addressRegion: region,
    addressCountry: country,
  }
}

function getEducationalOrganization({ name, address }) {
  const eduOrg = {
    "@type": "EducationalOrganization",
    name,
  }

  if (address) {
    eduOrg.address = getAddress(address)
  }

  return eduOrg
}

function getCredentials({ degreeName, degreeLevel, field }) {
  return {
    "@type": "EducationalOccupationalCredential",
    credentialCategory: degreeName,
    educationalLevel: degreeLevel,
    about: field,
  }
}

function getPerson({
  displayName,
  familyName,
  givenName,
  jobTitle,
  alumniOf,
  credential,
}) {
  const person = {
    "@type": "Person",
    name: displayName,
    familyName,
    givenName,
  }

  if (jobTitle) {
    person.jobTitle = jobTitle
  }

  if (alumniOf) {
    person.alumniOf = getEducationalOrganization(alumniOf)
  }

  if (credential) {
    person.hasCredential = getCredentials(credential)
  }

  return person
}

export function getWebsite({
  url,
  name,
  description,
  logoUrl,
  imageUrl,
  author,
}) {
  const schema = {
    "@type": "WebSite",
    url,
    name,
    description,
    author: getPerson(author),
    publisher: {
      "@type": "Organization",
      name,
    },
  }

  if (logoUrl) {
    schema.publisher.logo = logoUrl
  }

  if (imageUrl) {
    schema.image = imageUrl
  }

  return schema
}

function getPage({
  type = PAGE_TYPES.DEFAULT,
  title,
  siteUrl,
  pageUrl,
  imageUrl,
  description,
  datePublished,
  dateModified,
  author,
  logoUrl,
  siteName,
}) {
  const websiteSchema = getWebsite({
    name: siteName,
    url: pageUrl,
    description,
    imageUrl,
    logoUrl,
    author,
  })

  return {
    ...websiteSchema,
    "@type": type,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": siteUrl,
    },
    headline: title,
    datePublished: toISODate(datePublished),
    dateModified: toISODate(dateModified || datePublished),
  }
}

export function getSchema({
  type,
  title,
  siteUrl,
  pageUrl,
  imageUrl,
  description,
  datePublished,
  dateModified,
  author,
  logoUrl,
  siteName,
}) {
  const schema = title
    ? getPage({
        type,
        title,
        description,
        dateModified,
        datePublished,
        logoUrl,
        pageUrl,
        siteUrl,
        imageUrl,
        siteName,
        author,
      })
    : getWebsite({
        url: siteUrl,
        name: siteName,
        logoUrl,
        imageUrl,
        description,
        author,
      })

  return {
    "@context": "https://schema.org",
    ...schema,
  }
}
